import { Box, CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';
import { formatPrice } from '@ocx-app/lib/formatters/formatPrice';

import { List, ListItemStartIcon, ListItemNavLink, ListItemText, Paper, Typography } from '@ocx/ui';
import { CashbackIcon } from '@ocx/ui-icons';

import { profileMessages } from '../profile.messages';

export type CashbackMenuItemProps = {
  /** Cashback balance in cents. null/undefined shows Set up. */
  balance?: number | null;
  isLoading?: boolean;
};

export const CashbackMenuItem = ({ balance, isLoading = false }: CashbackMenuItemProps) => {
  const hasBalance = typeof balance === 'number';

  return (
    <Paper p={0} sx={{ overflow: 'hidden' }}>
      <List>
        <ListItemNavLink to={AppRoutePath.AllureCashback} disabled={isLoading}>
          <ListItemStartIcon>
            <CashbackIcon sx={{ fontSize: 22 }} />
          </ListItemStartIcon>
          <ListItemText>
            <FormattedMessage
              {...(isLoading || !hasBalance
                ? profileMessages['profile:cashback:title']
                : profileMessages['profile:cashback:balance-title'])}
            />
          </ListItemText>
          {/* eslint-disable-next-line no-nested-ternary */}
          {isLoading ? (
            <CircularProgress size={20} sx={{ ml: 'auto' }} />
          ) : hasBalance ? (
            <Typography variant="subtitle1" sx={{ ml: 'auto' }}>
              {formatPrice(balance)}
            </Typography>
          ) : (
            <Box
              sx={{
                ml: 'auto',
                px: 1.5,
                py: 0.75,
                borderRadius: 1,
                bgcolor: 'action.hover',
              }}>
              <Typography variant="subtitle2" color="primary.main" fontWeight={700} sx={{ textTransform: 'uppercase' }}>
                <FormattedMessage {...profileMessages['profile:cashback:set-up']} />
              </Typography>
            </Box>
          )}
        </ListItemNavLink>
      </List>
    </Paper>
  );
};
